import { useState } from "react";

const ContactScreen = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSend = async () => {
    try {

      const res = await fetch("https://us-central1-ai-build-ship-stream-as-l1mzrg.cloudfunctions.net/sendSupportEmail", {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          Authorization: "Basic " + btoa("quiz_admin:s*Q&FLx^9BUQ") 
        },
        body: JSON.stringify({ name, email, message }),
      });
      // Здесь можно добавить реальный API-запрос для отправки сообщения
      console.log("Отправляем:", { name, email, message });

      // Очистим поля после отправки
      setName("");
      setEmail("");
      setMessage("");

      console.log("Сообщение отправлено!");
    } catch (err) {
      console.error(err);
      console.log("Ошибка при отправке сообщения");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
      <p className="text-2xl font-semibold text-gray-800 mb-6">Contact us</p>

      {/* Поле для имени */}
      <input
        type="text"
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        className="w-[350px] max-w-md p-4 border border-gray-300 rounded-full mb-4 focus:outline-none focus:ring-2 focus:ring-pinkCustom"
      />

      {/* Поле для email */}
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-[350px] max-w-md p-4 border border-gray-300 rounded-full mb-4 focus:outline-none focus:ring-2 focus:ring-pinkCustom"
      />

      {/* Поле для текста сообщения */}
      <textarea
        placeholder="Message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows="5"
        className="w-[350px] max-w-md p-4 border border-gray-300 rounded-2xl mb-4 focus:outline-none focus:ring-2 focus:ring-pinkCustom"
      />

      {/* Кнопка отправки */}
      <button
        onClick={handleSend}
        className="w-[350px] max-w-md py-4 bg-pinkCustom text-white rounded-full hover:bg-pinkCustom transition"
      >
        Send
      </button>
    </div>
  );
};

export default ContactScreen;
